// OssUtils.js
import Vue from 'vue'

class OssUtils {
  constructor() {
    this.maxRetries = 10
    this.retryInterval = 600
    this.OSS = null // 缓存OSS构造函数，懒加载
  }

  // ✅ 异步加载OSS SDK，只加载一次
  async loadOSS() {
    if (this.OSS) return this.OSS
    const module = await import('ali-oss')
    this.OSS = module.default
    return this.OSS
  }

  async getCredentialWithRetry(retries = 0) {
    try {
      const c = await Vue.prototype.$stsCredential()
      if (!c) throw new Error('waiting')
      return c
    } catch (e) {
      if (retries < this.maxRetries) {
        await new Promise(r => setTimeout(r, this.retryInterval))
        return this.getCredentialWithRetry(retries + 1)
      }
      return null
    }
  }

  async initClient() {
    // 使用前先加载OSS
    await this.loadOSS()
    const c = await this.getCredentialWithRetry()
    return new this.OSS({
      region: c.region,
      accessKeyId: c.accessKeyId,
      accessKeySecret: c.accessKeySecret,
      stsToken: c.securityToken,
      bucket: c.bucket
    })
  }

  parseFilePath(filePath) {
    if (!filePath) return ''
    if (filePath.startsWith('https')) {
      const url = new URL(filePath)
      return url.pathname.slice(1)
    }
    return filePath
  }

  async getUrl(filePath, expires = 3600) {
    if (!filePath) return ''
    const client = await this.initClient()
    return client.signatureUrl(this.parseFilePath(filePath), { expires })
  }

  async batchGetUrls(filePaths, expires = 3600) {
    if (!filePaths.length) return []
    const client = await this.initClient()
    return Promise.all(filePaths.map(p => {
      if (!p) return null
      return client.signatureUrl(this.parseFilePath(p), { expires })
    }))
  }

  async getDownloadUrl(filePath, name, expires = 3600) {
    if (!filePath) return ''
    const client = await this.initClient()
    return client.signatureUrl(this.parseFilePath(filePath), {
      expires,
      response: { 'content-disposition': `attachment; filename="${encodeURIComponent(name)}"` }
    })
  }

  isOssPath(path) {
    return path && (path.startsWith('upload/') || path.startsWith('test/') || path.startsWith('http'))
  }

  extractFilePath(url) {
    return this.parseFilePath(url)
  }

  getFileExtension(path) {
    if (!path) return ''
    const i = path.lastIndexOf('.')
    return i > -1 ? path.slice(i + 1).toLowerCase() : ''
  }
}

const ossUtils = new OssUtils()

export default {
  install(Vue) {
    Vue.prototype.$oss = ossUtils
  }
}

export { ossUtils }
